export const LabelPlacementType = {
  LEFT: 'left',
  RIGHT: 'right'
};
export const LabelOrderType = {
  ONE: 1,
  TWO: 2
};
export const SwitchColor = {
  GREEN: 'green',
  BLUE: 'blue'
};